import { render, staticRenderFns } from "./Nature.vue?vue&type=template&id=5d08d787&"
import script from "./Nature.vue?vue&type=script&lang=js&"
export * from "./Nature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Nature.vue"
export default component.exports